import { makeStyles, Theme } from '@material-ui/core/styles'
import clsx from 'clsx'
import React, { ReactNode } from 'react'

const photosVideosGalleryTabPanelStyles = makeStyles((theme: Theme) => ({
    tabContainer: {
        margin: theme.spacing(1),
        height: 500,
    },
}))

export enum PhotosVideosGalleryEnum {
    Photos = 0,
    Videos = 1,
    Gallery = 2,
}

export interface PhotosVideosGalleryTabPanelProps {
    children: ReactNode
    index: PhotosVideosGalleryEnum
    value: PhotosVideosGalleryEnum
}

export const idPrefix = 'photosVideosGalleryTab'

export const a11yProps = (index: PhotosVideosGalleryEnum) => ({
    id: `${idPrefix}${index}`,
    'aria-controls': `${idPrefix}${index}`,
})

export const PhotosVideosGalleryTabPanel = ({
    children,
    index,
    value,
}: PhotosVideosGalleryTabPanelProps) => {
    const classes = photosVideosGalleryTabPanelStyles()
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`${idPrefix}${index}`}
            aria-labelledby={`${idPrefix}${index}`}
            className={clsx(
                classes.tabContainer,
                'photosVideosGalleryTabPanel'
            )}
        >
            {value === index && <>{children}</>}
        </div>
    )
}
